module.exports = __webpack_public_path__ + "static/media/sweep.312476a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/sweep.mp3
// module id = Moq0
// module chunks = 5